var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 239,
    viewBox: "0 0 193 239",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,239) scale(0.1,-0.1)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffffff",
    cx: 570,
    cy: 1390,
    rx: 300,
    ry: 300
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffffff",
    cx: 1360,
    cy: 1390,
    rx: 300,
    ry: 300
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7932b6",
    d: "M852 2369 c-216 -25 -412 -121 -571 -280 -121 -121 -202 -264 -254 -447 -21 -75 -22 -97 -25 -702 -1 -344 -1 -681 0 -750 l3 -124 109 149 c140 193 152 205 191 205 41 0 46 -6 145 -178 45 -79 93 -150 107 -159 13 -9 45 -18 71 -20 75 -7 97 14 192 179 46 78 90 151 98 161 19 21 75 23 95 2 9 -8 48 -72 88 -142 98 -174 127 -203 202 -203 62 0 95 35 189 194 47 82 92 152 100 157 7 5 27 9 45 9 29 0 40 -11 160 -177 l128 -178 3 110 c2 61 1 396 -1 745 -4 697 -3 687 -68 848 -84 212 -259 402 -464 505 -100 49 -216 84 -328 96 -106 12 -110 12 -215 0z m-174 -723 c207 -105 198 -396 -16 -494 -46 -21 -65 -24 -121 -20 -80 6 -134 32 -185 88 -91 100 -97 237 -17 347 32 44 101 90 154 104 52 13 131 3 185 -25z m807 9 c49 -21 112 -80 137 -129 13 -24 23 -68 26 -109 4 -61 2 -73 -28 -133 -48 -98 -131 -152 -236 -153 -155 -3 -274 115 -274 270 0 135 71 230 200 266 51 14 122 9 175 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M627 1502 c-51 -57 21 -140 82 -95 32 24 39 68 15 94 -22 24 -76 25 -97 1z m80 -36 c-4 -9 -11 -16 -17 -16 -17 0 -24 31 -9 41 18 11 34 -5 26 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M1446 1498 c-9 -12 -16 -31 -16 -41 0 -24 44 -67 70 -67 50 0 80 79 42 113 -27 25 -78 22 -96 -5z m81 -14 c8 -20 -8 -36 -26 -25 -15 10 -8 41 9 41 6 0 13 -7 17 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo-4.a10d0f496e9f4dd9203dbb39e1c4c694.svg";
export { ForwardRef as ReactComponent };